<template>
  <slot :products="products" />
</template>

<script>
import productIdQuery from "@/graphql/queries/ProductId.gql";

export default {
  name: "NostoCarouselHelper",
  props: {
    recommendations: {
      type: Array,
      default: () => [],
    },
    placementId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      products: [],
    };
  },
  created() {
    this.getProducts();
  },
  methods: {
    async getProducts() {
      const promises = [];

      if (!this.recommendations) {
        return;
      }

      this.recommendations.forEach((product) => {
        promises.push(
          this.$apollo.query({
            query: productIdQuery,
            variables: {
              productId: "gid://shopify/Product/" + product.product_id,
            },
          })
        );
      });

      Promise.all(promises).then((values) => {
        values.map((value) => {
          const product = this.productWithReferralPlacement(value.data.product);
          this.products.push(product);
        });
      });
    },
    productWithReferralPlacement(product) {
      if (!this.placementId) {
        return product;
      }

      const newOnlineStoreUrl = new URL(product.onlineStoreUrl);
      newOnlineStoreUrl.searchParams.set("ref-placement", this.placementId);

      return {
        ...product,
        onlineStoreUrl: newOnlineStoreUrl,
      };
    },
  },
};
</script>
